import { render, staticRenderFns } from "./TopSalesTable.vue?vue&type=template&id=099e8baf"
import script from "./TopSalesTable.vue?vue&type=script&lang=js"
export * from "./TopSalesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports